module.exports = __webpack_public_path__ + "fonts/fzlishu.e51d687a.ttf";